import {Provider} from 'react-redux';
import {ThemeProvider} from '@mui/material/styles';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import {ScrollProvider} from './components/ScrollContext';
import './App.css';
import theme from './theme';
import {store} from './redux/store';
import Routes from './router';
import AuthProvider from './components/AuthProvider.tsx';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ScrollProvider>
            <AuthProvider>
              <Routes />
            </AuthProvider>
          </ScrollProvider>
        </Provider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
